/**
 * FullPageCenter — DS Layout
 * Centrage absolu vertical + horizontal — pages vides, loaders, erreurs 404
 */

import styles from './FullPageCenter.module.css';

interface FullPageCenterProps {
  children: React.ReactNode;
  withBackground?: boolean;
  className?: string;
}

export function FullPageCenter({ children, withBackground = true, className = '' }: FullPageCenterProps) {
  return (
    <div className={`${styles.root} ${withBackground ? styles.bg : ''} ${className}`}>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
